import moment from 'moment';

const globalDateFormat = 'MMM DD, YYYY';
const globalDateTimeFormat = 'MMM DD, YYYY h:mm A';
const globalTimeFormat = 'h:mm A';

export const convertUTCDateStringToLocalDate = (dateString) => {
  if (dateString == '' || dateString == undefined || dateString == null)
    return '';
  let utcDateStr = dateString.includes('Z')
    ? dateString
    : dateString.includes('.')
      ? `${dateString}Z`
      : `${dateString}.000Z`;
  return new Date(utcDateStr);
};

export const convertUTCDateToLocalDateStringFormat = (
  date,
  time = false,
  format = ''
) => {
  if (date == '' || date == undefined || date == null) return '';
  let utcDate =
    date instanceof Date || date.includes('Z')
      ? date
      : date.includes('.')
        ? `${date}Z`
        : `${date}.000Z`;
  const dateTimeFormat = format == '' ? 
  time ?  globalDateTimeFormat: globalDateFormat : format;
  if(time){
    return moment(new Date(utcDate)).format(dateTimeFormat);
  }
  return moment(new Date(utcDate)).format(dateTimeFormat);
};

export const covertUTCDateTimeToLocalTimeStringFormat = (dateTime) => {
  if (dateTime == '' || dateTime == undefined || dateTime == null) return '';
  let utcDateTime =
    dateTime instanceof Date || dateTime.includes('Z')
      ? dateTime
      : dateTime.includes('.')
        ? `${dateTime}Z`
        : `${dateTime}.000Z`;
  return moment(new Date(utcDateTime)).format(globalTimeFormat);
};